import React, { useEffect, useState } from 'react';
import { 
	Input,
	Card, 
	CardHeader, 
	CardBody, 
	Row,
	Col,
	Container,
	Offcanvas, 
	OffcanvasBody
 } from "reactstrap";

import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import * as moment from "moment";

import BreadCrumb from "../../Components/Commons/BreadCrumb";
import Pagination from "../../Components/Commons/Pagination";
import SendInputsTable from "./SendInputsTable";

import Cookies from 'js-cookie';
import axios from "axios";
import Flatpickr from "react-flatpickr";
import { useAsyncDebounce } from "react-table";


import {
	useGetSendInputsQuery
} from '../../api/api'

const PayloadDetail = () => {

	const { t } = useTranslation();

	const [currentPage, setCurrentPage] = useState(1);
	const [webserviceSearch, setWebserviceSearch] = useState(null);
	const [creationStartDate, setCreationStartDate] = useState(null);
	const [creationEndDate, setCreationEndDate] = useState(null);

	const [isOpen, setIsOpen] = useState(false);
	const [sideBarSendInput, setSideBarSendInput] = useState(null);
	const [loadingDetail, setLoadingDetail] = useState(false);

	const { 
		data: sendInputs,
		error: sendInputsError,
		isFetching: isSendInputsLoading,
		isSuccess: isSendInputsSuccess
	} = useGetSendInputsQuery(
		{ 
			page: currentPage,
			filter: webserviceSearch,
			creationStartDate: creationStartDate,
			creationEndDate: creationEndDate,
			page_size: 10
		}, 
		{
			refetchOnMountOrArgChange: true,
			skip: false,
			pollingInterval: 30000,
		}
	);

	const handleExport = (send_input) => {
		let token = JSON.parse(Cookies.get("authUser")).token;
		axios.get(`send-inputs/${send_input.reference}/export_data/`, 
			{
				headers: { 'Authorization': `Token ${token}` },
				responseType: 'blob'
			}
		).then((response) => {
			if(send_input.web_service.protocol_kind === 2){
				saveAs(response, `payload_${Date.now()}.xml`);
			} else {
				saveAs(response, `payload_${Date.now()}.json`);
			}
		});
	};

	const handleDetailsPressed = async (sendInput) => {
		setIsOpen(true);
		setSideBarSendInput(sendInput); // muestra algo de inmediato mientras carga
		setLoadingDetail(true);

		try {
			let token = JSON.parse(Cookies.get("authUser")).token;
			const response = await axios.get(
				`send-inputs/${sendInput.reference}/`,
				{ headers: { 'Authorization': `Token ${token}` } }
			);
			setSideBarSendInput(response);
		} catch (error) {
			console.error("Error fetching send input detail", error);
		} finally {
			setLoadingDetail(false);
		}
	};


	const onChange = useAsyncDebounce((value) => {
		setWebserviceSearch(value);
	}, 200);

	/*useEffect(() => {
		if (sendInputs) {
			debugger;
		}
	}, [sendInputs]);*/

	document.title = t("WebService Data Replication");

	return (
		<React.Fragment>
			<div className="page-content">
				<Container fluid>
					<Offcanvas
						isOpen={isOpen}
						direction="end"
						toggle={() => setIsOpen(!isOpen)}
						className="offcanvas-end border-0"
						tabIndex="-1"
						id="member-overview"
					>

						<OffcanvasBody className="profile-offcanvas p-0">
							<div className="p-3">
								<h5 className="fs-15 mb-3">{t("Send Input Details")}</h5>

								{loadingDetail ? (
									<div className="text-center py-4">
										<span className="spinner-border spinner-border-sm me-2" />
										{t("Loading...")}
									</div>
								) : (
									<>
										<div className="mb-3">
											<p className="text-muted text-uppercase fw-semibold fs-12 mb-2">{t("Last Payload Sent")}</p>
											<h6>
												{sideBarSendInput ? sideBarSendInput.payload : ''}
											</h6>
										</div>
										<div className="mb-3">
											<p className="text-muted text-uppercase fw-semibold fs-12 mb-2">{t("Last Web Service Return")}</p>
											<h6>
												{sideBarSendInput ? JSON.stringify(sideBarSendInput.response) : ''}
											</h6>
										</div>
										<div className="mb-3">
											<p className="text-muted text-uppercase fw-semibold fs-12 mb-2">{t("Last Error Response")}</p>
											<h6>
												{sideBarSendInput ? sideBarSendInput.errors : ''}
											</h6>
										</div>
									</>
								)}
							</div>
						</OffcanvasBody>
					</Offcanvas>
					<BreadCrumb title={t("payload")} pageTitle={t("start")} />
					<Row>
						<Col xxl={12}>
							<Card id="orderList">
								<CardHeader className="align-items-center d-flex">
									<h4 className="card-title mb-0 flex-grow-1">{t("Last Data Send Tasks")}</h4>
								</CardHeader>
								<CardBody className="pt-0">
									<div>
										<Row className="mb-3">
											<CardBody className="border border-dashed border-end-0 border-start-0">
												<form>
													<Row>
														<Col md={3}>
															<Input
                                name="orderId"
                                id="id-field"
                                className="form-control"
                                placeholder={t("Search")}
                                type="text"
                                onChange={(e) => {
                                  setCurrentPage(1);
                                  onChange(e.target.value);
                                }}
															/>
														</Col>

														<Col md={3}>
															<Flatpickr
                                className="form-control"
                                id="datepicker-created-at"
                                placeholder={t("Created at")}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  mode: "range",
                                  dateFormat: "DD-MM-YYYY",
                                }}
                                onChange={(date) => {
                                  setCurrentPage(1);
                                  if(date[0]!== undefined){
                                    const date1 = moment(date[0]).format("DD-MM-YYYY");
                                    setCreationStartDate(date1);
                                  } else {
                                    setCreationStartDate(null);
                                  }
                                  if(date[1]!== undefined){
                                    const date1 = moment(date[1]).format("DD-MM-YYYY");
                                    setCreationEndDate(date1);
                                  } else {
                                    setCreationEndDate(null);
                                  }
                                }}
															/>
														</Col>
													</Row>
												</form>
											</CardBody>
										</Row>
										<SendInputsTable
											data={(sendInputs && sendInputs.results || [])}
											isLoading={isSendInputsLoading}
											isSuccess={isSendInputsSuccess}
											error={sendInputsError}
											isGlobalFilter={false}
											customPageSize={25}
											divClass="table-responsive table-card mb-1"
											tableClass="align-middle table-nowrap"
											theadClass="table-light text-muted"
											onDetailsPressed={handleDetailsPressed}
											onDownloadPressed={(sendInput) => {
												handleExport(sendInput);
											}}
										/>
									</div>
									{sendInputs && !isEmpty(sendInputs.results) && (
										<Pagination
											totalRows={sendInputs.count}
											pageChangeHandler={setCurrentPage}
											rowsPerPage={25}
										/>
									)}
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default PayloadDetail;
